import React from "react";
import { useTheme } from "@emotion/react";
import { ButtonVariant } from "@bale/ui";
import Modal from "components/commons/modal/Modal";
import { strings } from "intl/fa";
import styles from "./PriceChangeModal.module.scss";
import { digitsToHindi } from "@bale/utils";

interface Props {
  onPrimaryClicked: () => void;
  primaryText?: string;
  onClose?: () => void;
  changeInfo: {
    beforePrice: number;
    afterPrice: number;
  };
  secondaryButton?:
    | undefined
    | {
        onSecondaryClicked: () => void;
        secondaryText?: string;
        color?: string;
      };
  currency?: string;
  title: string;
  description: string;
  labelText: string;
}

const PriceChangeModal: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const theme = useTheme();

  return (
    <Modal
      title={props.title}
      onClose={props.onClose}
      primaryButton={{
        label: props.primaryText ?? strings.common.button.sure,
        disable: undefined,
        onClick: () => props.onPrimaryClicked?.(),
      }}
      secondaryButton={
        props.secondaryButton
          ? {
              label:
                props.secondaryButton.secondaryText ??
                strings.common.button.cancel,
              onClick: () => props.secondaryButton?.onSecondaryClicked(),
              // color: props.secondaryButton.color ?? theme.colors.dark[200],
              // variant: ButtonVariant.Outlined,
            }
          : undefined
      }
    >
      <div className={styles.Container}>
        <div className={styles.PriceWrapper}>
          <div className={styles.PriceText}>{props.labelText}</div>
          <div className={styles.Price}>
            {digitsToHindi(String(props.changeInfo.beforePrice))}{" "}
            {props.currency || strings.common.toman}
          </div>
          <img src={"/icons/right_arrow.svg"} alt="" />
          <div className={`${styles.Price} ${styles.Strikedthrough}`}>
            {digitsToHindi(String(props.changeInfo.afterPrice))}{" "}
            {props.currency || strings.common.toman}
          </div>
        </div>
        <div className={styles.WarningText}>{props.description}</div>
      </div>
    </Modal>
  );
};

export default PriceChangeModal;
